module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-ThinItalic.9d5ed420.otf";